import React from "react";
import AdminSidebar from "../../components/layout/AdminSidebar";
import Footer from "../../components/layout/Footer";
import AdminCard from "../../components/admin/AdminCard";

export default function AdminHome() {
    return (
        <div className="flex min-h-screen bg-gray-50 font-body">
            {/* Admin Sidebar */}
            <AdminSidebar />

            {/* Main Content - offset by sidebar width on desktop only */}
            <div className="flex-1 md:ml-64 flex flex-col">
                <main className="flex-grow">
                    {/* Header Section */}
                    <div className="bg-gradient-to-r from-forest to-leaf py-12">
                        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                            <div className="text-center">
                                <h1 className="font-heading text-4xl font-bold text-white sm:text-5xl">
                                    Admin
                                </h1>
                                <p className="mt-4 text-lg text-white/90">
                                    Hantera innehåll och inställningar
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Admin Cards Grid */}
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                            
                            {/* Card 1 - Redigera artlista */}
                            <AdminCard
                                icon={
                                    <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                    </svg>
                                }
                                title="Redigera artlista"
                                description="Här kan du lägga till nya arter i en existerande lista eller skapa en ny lista"
                                linkTo="/admin-arter"
                                linkText="Öppna"
                            />

                            {/* Card 2 - Redigera quizfrågor */}
                            <AdminCard
                                icon={
                                    <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                }
                                title="Redigera quizfrågor"
                                description="Här kan du redigera och lägga till nya quizfrågor."
                                linkTo="/admin-quiz"
                                linkText="Öppna"
                            />

                            {/* Card 3 - Redigera naturområde */}
                            <AdminCard
                                icon={
                                    <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
                                    </svg>
                                }
                                title="Redigera naturområde"
                                description="Här kan du redigera och lägga till ett nytt naturområde."
                                linkTo="/admin-omraden"
                                linkText="Öppna"
                            />

                        </div>
                    </div>
                </main>

            </div>
        </div>
    );
}
